import { createFileRoute } from "@tanstack/react-router";

import { OrganisationForm } from "@/components/OrganisationForm";

export const Route = createFileRoute("/_authenticated/organisations/$slug/")({
  component: OrganisationDetailPage,
});

function OrganisationDetailPage() {
  const { slug } = Route.useParams();

  // Handle "create" as a special case - don't pass slug for create mode
  const isCreateMode = slug === "create";

  return <OrganisationForm slug={isCreateMode ? undefined : slug} />;
}
